import ClientBase from "../ClientBase";
import MarkerProvenance from "@/domain/marker/MarkerProvenance";

class MarkerProvenanceClient extends ClientBase {

    async getByScanId(scanId) {
        const data = await this.get(`api/v1/markerprovenance/scans/${scanId}`);
        return data?.map(record => new MarkerProvenance(record)) ?? [];
    }

    async getCountByScanId(scanId) {
        const data = await this.get(`api/v1/markerprovenance/scans/${scanId}/count`);
        return data?.count ?? 0;
    }

    async getById(scanId, id) {
        const data = await this.get(`api/v1/markerprovenance/scans/${scanId}/${id}`);
        return data ? new MarkerProvenance(data) : null;
    }

    // Create one provenance record — the app path for a manually-drawn marker's traceability.
    async create(model) {
        const data = await this.post(`api/v1/markerprovenance`, model);
        return data ? new MarkerProvenance(data) : null;
    }

    async reviewById(scanId, id, review) {
        const data = await this.put(`api/v1/markerprovenance/scans/${scanId}/${id}/review`, review);
        return data ? new MarkerProvenance(data) : null;
    }

    // COCO retraining dataset (reviewed TPs + human FN boxes). classNames is an array;
    // it's sent comma-joined so the API can bind it as one query param.
    async exportDataset(scanId, { classNames, workflowId, includeUnreviewed } = {}) {
        const params = {};
        if (Array.isArray(classNames) && classNames.length) params.classNames = classNames.join(',');
        if (workflowId) params.workflowId = workflowId;
        if (includeUnreviewed) params.includeUnreviewed = includeUnreviewed;
        return await this.get(`api/v1/markerprovenance/scans/${scanId}/export`, params);
    }

    async deleteById(scanId, id) {
        return await this.delete(`api/v1/markerprovenance/scans/${scanId}/${id}`);
    }

    async deleteByScanId(scanId) {
        return await this.delete(`api/v1/markerprovenance/scans/${scanId}`);
    }
}

export default new MarkerProvenanceClient();
